import React from 'react';
import { useTranslation } from 'react-i18next';

import { ManageContractsApp } from '../contractManagementContext';
import ManageContractsAddressFields from '../ManageContractsAddressFields';

export const NewAddress: React.FunctionComponent = () => {
  const { t } = useTranslation();

  const { selectedForm, createNewContract, newAddress } = ManageContractsApp.useState();

  return (
    <section className="manage-contracts-step stepNewAddress">
      {selectedForm === 1 && createNewContract === true && <h3>{t('manageContracts:manageContracts.NewAddressTitleForm1')}*</h3>}
      {selectedForm === 2 && <h3>{t('manageContracts:manageContracts.NewAddressTitleForm2')}*</h3>}

      {((selectedForm === 1 && createNewContract === true) || selectedForm === 2) && <p>{t('manageContracts:manageContracts.NewAddressBody')}</p>}

      <ManageContractsAddressFields address={newAddress} action="newAddress" showNameFields={false} showSSN={false} showMobilePhoneNumber={false} />
    </section>
  );
};

export default NewAddress;
